// AGENTS.md 编辑（执行 agent 的硬规则），保存需填「为什么」
import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAction, useLoad } from "../../lib/hooks";
import { useDialog } from "../../components/Dialogs";
import { useAlerts } from "../../lib/alerts";
import { SubTabs, SYSTEM_TABS } from "../../components/SubTabs";
import { PageHeading } from "../../components/PageHeading";

export function AgentsMdPage() {
  const q = useLoad(() => api.agentsMd(), []);
  const [content, setContent] = useState("");
  const act = useAction();
  const dialog = useDialog();
  const { toast } = useAlerts();
  useEffect(() => {
    if (q.data) setContent(q.data.content ?? "");
  }, [q.data]);
  const dirty = q.data && content !== (q.data.content ?? "");
  const save = async () => {
    const why = await dialog.prompt({ title: "保存 AGENTS.md", label: "为什么改（会记进变更账本）", required: true, okText: "保存" });
    if (!why) return;
    const r = await act.run("save", () => api.updateAgentsMd(content, why));
    if (r) {
      toast("ok", `已保存（${r.commit.slice(0, 7)}）`);
      void q.reload();
    }
  };
  return (
    <div>
      <PageHeading
        title="AGENTS.md"
        desc={
          <>
            所有执行 agent 的硬规则；保存要填「为什么」，会记进变更账本
            {q.data?.sha && <span className="mono"> · 当前 {q.data.sha.slice(0, 12)}</span>}
          </>
        }
      >
        {dirty && <span className="muted small">有未保存的修改</span>}
        <button className="btn btn-primary" disabled={!dirty || !!act.busy} onClick={() => void save()}>
          {act.busy ? "正在保存…" : "保存 AGENTS.md"}
        </button>
      </PageHeading>
      <SubTabs tabs={SYSTEM_TABS} />
      <div className="warning-block">
        这是所有执行 agent 的硬规则（禁止碰提交按钮、每步截图、不确定就 block 等）。改动会影响所有任务类型，并产生一条变更标记。
      </div>
      {act.error && <div className="notice err">{act.error}</div>}
      {q.error && <div className="notice err">{q.error}</div>}
      <div className="card">
        {q.loading && !q.data ? (
          <div className="empty">正在加载…</div>
        ) : (
          <textarea className="code" aria-label="AGENTS.md 内容" value={content} onChange={(e) => setContent(e.target.value)} spellCheck={false} />
        )}
      </div>
    </div>
  );
}
